<div class="row {{ additionalClassFirstSection }}">
  <div class="col-auto">
   <ng-content></ng-content>
  </div>
  <div class="col">
    <label class="custom-control-label {{ additionalClassInDescriptionOfTerms }}"
           for="{{ idOfField }}">
      Autorizo o processamento dos meus dados pela Rodobens para o
      envio de informações comerciais personalizadas, inclusive
      preparando perfis com base nas informações obtidas de acordo
      com as disposições da
      <a [href]="politicaPrivacidade.url"
         target="_blank"
         rel="noopener"
         class="text-info d-inline-block"
         aria-label="Política de Privacidade"
         title="Política de Privacidade">
        Politica de Privacidade</a>.
    </label>
    <ng-container *ngIf="getCampo(formGroup,'politicaPrivacidade').errors?.required">
      <span class="invalid-feedback">
        Por favor, selecione o campo Política de privacidade
      </span>
    </ng-container>
  </div>
</div>
